import { createSelector } from 'reselect'

export const getRegions = createSelector(
  (state) => state.geoObjects && state.geoObjects.regions && state.geoObjects.regions.elements
    ? state.geoObjects.regions.elements
    : [],
  (regions) => regions
)
